import { Tooltip, makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { BodyM } from 'components/Typography/Typography';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/cellWithTooltipStyle';
import { ExtractKey } from 'views/PaymentsHistory/constants';

interface ICellWithTooltip {
	list: IList[];
	extractKey: string; //key to be used to extract the bill details like billingId, billNumber. The key to be shown on the list with tooltip.
}

interface IList {
	billNumber: string;
	billingId?: string;
}

// @ts-ignore
const useStyles = makeStyles(styles);
export const CellWithTooltip = ({ list = [], extractKey }: ICellWithTooltip) => {
	const classes = useStyles();
	return (
		<div className={classes.wrapper}>
			<BodyM inline>{list[0]?.[extractKey]}</BodyM>
			<ConditionalRender
				show={list.length > 1}
				onTrue={() => (
					<Tooltip
						placement="right"
						arrow
						title={
							<div className={classes.billNumberList}>
								{list.map((bills, index) => {
									return index !== 0 ? (
										<BodyM customClassName={classes.toolTip} key={index}>
											{bills[extractKey]}
										</BodyM>
									) : (
										''
									);
								})}
							</div>
						}
					>
						<p className={classes.toolTipicon}>{`+${list.length - 1}`}</p>
					</Tooltip>
				)}
			/>
		</div>
	);
};
